"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ui = require("../../../../../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Actions = function Actions(_ref) {
  var prevBtnProps = _ref.prevBtnProps,
    nextBtnProps = _ref.nextBtnProps,
    className = _ref.className;
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Row, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ui.Col, null, /*#__PURE__*/_react.default.createElement(_ui.OutlineButton, _extends({
    wide: true,
    children: t('back')
  }, prevBtnProps))), /*#__PURE__*/_react.default.createElement(_ui.Col, null, /*#__PURE__*/_react.default.createElement(_ui.Button, _extends({
    color: "secondary",
    type: "button",
    wide: true,
    children: t('next')
  }, nextBtnProps))));
};
exports.Actions = Actions;